"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Volume = void 0;
const react_1 = __importStar(require("react"));
const Slider_1 = __importDefault(require("@material-ui/core/Slider"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const VolumeDown_1 = __importDefault(require("@material-ui/icons/VolumeDown"));
const VolumeOff_1 = __importDefault(require("@material-ui/icons/VolumeOff"));
const VolumeUp_1 = __importDefault(require("@material-ui/icons/VolumeUp"));
const shared_hooks_use_boolean_1 = require("@guidde-co/shared.hooks.use-boolean");
const renderIcon = (value) => {
    switch (value) {
        case 0:
            return react_1.default.createElement(VolumeOff_1.default, { fontSize: "inherit", color: "inherit" });
        case 100:
            return react_1.default.createElement(VolumeUp_1.default, { fontSize: "inherit", color: "inherit" });
        default:
            return react_1.default.createElement(VolumeDown_1.default, { fontSize: "inherit", color: "inherit" });
    }
};
const useStyles = (0, makeStyles_1.default)({
    icon: {
        cursor: 'pointer',
        fontSize: '20px',
        minWidth: '23px',
        color: 'white'
    },
    sliderRoot: {
        padding: '5px 0'
    },
    sliderThumb: {
        boxShadow: 'none !important',
        '&:after': {
            top: '-2px !important',
            left: '-2px !important',
            right: '-2px !important',
            bottom: '-2px !important'
        }
    }
});
exports.Volume = (0, react_1.memo)(({ videoElement }) => {
    const classes = useStyles();
    const hover = (0, shared_hooks_use_boolean_1.useBoolean)();
    const active = (0, shared_hooks_use_boolean_1.useBoolean)();
    const [value, setValue] = react_1.default.useState(100);
    const handleChange = (_event, newValue) => {
        setValue(newValue);
        if (videoElement) {
            videoElement.volume = newValue / 100;
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener('mouseup', active.setFalse);
        return () => window.removeEventListener('mouseup', active.setFalse);
    }, [active.setFalse]);
    if (!videoElement)
        return null;
    return (react_1.default.createElement(Box_1.default, { display: "flex", onMouseEnter: hover.setTrue, onMouseLeave: hover.setFalse, onMouseDown: active.setTrue, alignItems: "center", mx: 1 },
        react_1.default.createElement(Box_1.default, { display: "flex", className: classes.icon, onClick: () => {
                setValue(value ? 0 : 100);
                videoElement.volume = value ? 0 : 1;
            } }, renderIcon(value)),
        react_1.default.createElement(Box_1.default, { mx: 1, display: hover.isFalse && active.isFalse ? 'none' : 'flex' },
            react_1.default.createElement(Slider_1.default, { value: value, onChange: handleChange, classes: {
                    root: classes.sliderRoot,
                    thumb: classes.sliderThumb
                }, style: { width: '100px' } }))));
});
//# sourceMappingURL=volume.js.map